import { Dialog } from '@mui/material';
import React from 'react';

interface VyModalCropperProps {
  children: (onClose: () => void, onSubmit: () => void) => JSX.Element;
  onClose?: () => void;
  onSubmit?: () => any;
  title?: string;
  open?: boolean;
  displayCloseButton?: boolean;
  hasDefaultPadding?: boolean; // wether the modal has a padding by default
  maxWidth?: string | number;
  disableDefaultStyling?: boolean;
  withRotation?: boolean;
}

export default function VyModalCropper({
  children,
  onClose = () => {},
  onSubmit = () => {},
  title = '',
  displayCloseButton = false,
  open = false,
  hasDefaultPadding = true,
  maxWidth = '350px',
  disableDefaultStyling = false,
}: VyModalCropperProps) {
  // useEffect(() => {
  //   if (open) {
  //     windowOffset = window.scrollY;
  //     document.body.setAttribute('style', `position: fixed; left: 0; right: 0; top: -${windowOffset}px`);
  //   } else {
  //     document.body.setAttribute('style', '');
  //     window.scrollTo(0, windowOffset);
  //   }
  // }, [open]);
  if (!open) return null;

  return (
    <>
      <Dialog
        open={true}
        onClose={() => onClose?.()}
        fullScreen
        sx={{
          padding: 0,
          zIndex: 1400,
          '& .MuiPaper-root': { width: '100vw', maxWidth: '100vw', height: '100dvh', maxHeight: '100vh', backgroundColor: '#00000000' },
        }}>
        {children(onClose, onSubmit)}
      </Dialog>
    </>
  );
}
